// Score-to-percentile mapping based on statistical simulation
export function getPercentile(score: number, mean: number = 16, sd: number = 15): number {
  const z = (score - mean) / sd;

  const t = 1 / (1 + 0.2316419 * Math.abs(z));
  const d = 0.3989422804014327; // 1/sqrt(2*pi)
  const p = d * Math.exp(-z * z / 2) *
    (t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.8212560 + t * 1.3302744)))));

  const percentile = z > 0 ? (1 - p) * 100 : p * 100;

  return Math.round(Math.min(99, Math.max(1, percentile)));
}
